module.exports = __webpack_public_path__ + "img/profile-pic.4eca2483.png";